/**
 * Defines the event-specific keys for CMCD (Common Media Client Data) version 2.
 *
 * @public
 */
export const CMCD_EVENT_KEYS = [
	'cen',
	'e',
	'h',
	'ts',
] as const
